import "components/recipe/Recipe.css";
import { RecipeContext } from "components/recipe/providers/RecipeProvider";
import { useAuthentication } from "authentication/AuthenticationContext";
import { Link } from "react-router-dom";
import BaseButton from "base/BaseButton";
import AddRecipeButton from "components/recipe/AddRecipeButton";
import loadingLogo from "images/BlogFreeRecipeLogo.png";
import React, { useEffect, useMemo, useState, useContext } from "react";
import RecipeCard from "components/recipe/RecipeCard";
import recipesToItemListJsonLd from "searchOptimizations/recipesToItemListJsonLd";

const RecipeList = ({ onAdd, recipes, recipeView, onRecipeViewChange }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { featureToggles } = useContext(RecipeContext);
  const { user } = useAuthentication();
  const isMyRecipes = recipeView === "mine";

  const renderPinItBtn = () => {
    const script = document.createElement("script");
    script.async = true;
    script.type = "text/javascript";
    script.dataset.pinBuild = "doBuild";
    script.src = "//assets.pinterest.com/js/pinit.js";
    document.body.appendChild(script);
    if (window.doBuild) window.doBuild();
    if (window.parsePinBtns)
      window.parsePinBtns(document.getElementById("pin-it-buttons"));
  };

  useEffect(() => {
    //render Pinterest button on load
    renderPinItBtn();
  }, []);

  useEffect(() => {
    //use isLoading to show spinner until recipes have loaded
    if (recipes.length > 0) setIsLoading(false);
  }, [recipes]);

  useEffect(() => {
    //search optimizations
    recipesToItemListJsonLd(recipes, "https://blogfreerecipe.com");
  }, [recipes]);

  const amazonLinkStatus = useMemo(
    () => featureToggles.find((f) => f.name.includes("Amazon"))?.isEnabled,
    [featureToggles],
  );

  const handleAddRecipe = () => {
    onAdd();
  };

  return (
    <>
      {amazonLinkStatus && (
        <div className="marg-t-3 Justify-Center">
          <iframe
            src="//rcm-na.amazon-adsystem.com/e/cm?o=1&p=42&l=ur1&category=kitchen&banner=09RE3AASKRA6TA2H9K82&f=ifr&linkID=fcf06002557fde8c7826d4f6b2d6cb16&t=blogfreerecip-20&tracking_id=blogfreerecip-20"
            width="234"
            height="60"
            border="0"
            sandbox="allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation"
          ></iframe>
        </div>
      )}
      <h2 className="Sub-Heading Justify-Center marg-t-1">
        For those who ...<span className="TLDR">TLDR</span>
      </h2>
      <div role="group" aria-label="Recipe collection" className="recipe-tabs">
        <BaseButton
          buttonType="button"
          buttonText="All Recipes"
          buttonClass={`recipe-tab ${!isMyRecipes ? "recipe-tab--active" : ""}`}
          isUnstyled
          ariaPressed={!isMyRecipes}
          handleClick={() => onRecipeViewChange("all")}
        />

        <BaseButton
          buttonType="button"
          buttonText="My Recipes"
          buttonClass={`recipe-tab ${isMyRecipes ? "recipe-tab--active" : ""}`}
          isUnstyled
          ariaPressed={isMyRecipes}
          handleClick={() => onRecipeViewChange("mine")}
        />
      </div>

      <div className="m1-5">
        {isMyRecipes && !user ? (
          <div className="recipe-collection-empty">
            <h2>Your recipes, in one place</h2>
            <p>Sign in to view and store your own recipes.</p>
            <Link to="/login">Sign in</Link>
            {" · "}
            <Link to="/signup">Create an account</Link>
          </div>
        ) : isMyRecipes && recipes.length === 0 ? (
          <div className="recipe-collection-empty">
            <h2>No recipes to show</h2>
            <p>Add your first recipe, or check your current filters.</p>
            <BaseButton
              buttonType="button"
              buttonText="+ Add Recipe"
              handleClick={handleAddRecipe}
            />
          </div>
        ) : isLoading ? (
          <div className="Justify-Content" id="Logo">
            <img
              className="loading Justify-Center"
              src={loadingLogo}
              alt="spinning logo"
              id="Logo"
            />
          </div>
        ) : recipes.length === 0 ? (
          <div className="recipe-collection-empty">
            <p>No recipes match your search or filters.</p>
          </div>
        ) : (
          <>
            {recipes?.map((recipe, index) => (
              <React.Fragment key={recipe.id}>
                {index % 5 === 0 && index !== 0 && amazonLinkStatus && (
                  <div className="Justify-Center A-Center marg-b-1">
                    {/* <AmazonAd size="large" /> */}
                  </div>
                )}
                <RecipeCard
                  recipe={recipe}
                  amazonLinkStatus={amazonLinkStatus}
                />
              </React.Fragment>
            ))}
          </>
        )}
      </div>
      <AddRecipeButton onAdd={handleAddRecipe} />
    </>
  );
};

export default RecipeList;
